import toastr from "toastr"
import "toastr/build/toastr.min.css"

const showWanringToast = (message = "message") => {
  toastr.options = {
    positionClass: "toast-top-full-width",
    closeButton: true,
    showMethod: "slideDown",
    hideMethod: "slideUp",
    preventDuplicates: true,
  }

  toastr.warning(message)
}

export { showWanringToast }
